<ul class="slideindicator">
    @if (indicatorArrow) {
        <span class="theme-left" [class.hidden-visibility]="isActive(0)" (click)="arrowClick(arrowDirections.Left)"> </span>
    }
    @for (slide of indicators; track slide; let i = $index) {
        <li class="indicator" [class.active]="isActive(i)" (click)="indicatorClick(i); $event.stopPropagation()"></li>
    }
    @if (indicatorArrow) {
        <span class="theme-right" [class.hidden-visibility]="isActive(realtotalslidecount - 1)" (click)="arrowClick(arrowDirections.Right)"> </span>
    }
</ul>
